import { ChartElementHandler } from './chart.element-handler';

export class BarChartElementHandler extends ChartElementHandler<'chartBar'> {
  readonly type = 'chartBar';
  readonly flipXY = true;
}
